export default __webpack_public_path__ + "static/media/giphy2.dcb152c0.gif";